import { render, staticRenderFns } from "./EditContactList.vue?vue&type=template&id=7ae1e960&"
import script from "./EditContactList.vue?vue&type=script&lang=js&"
export * from "./EditContactList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports